/**
 * @generated SignedSource<<43e31ac1518d2be0e85af0936baa5e6a>>
 * @relayHash 475721f730a3548a4f4eefeb978ba00d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb

import type { ConcreteRequest } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type useUserByLicensedProductsQuery$variables = Record<PropertyKey, never>;
export type useUserByLicensedProductsQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null | undefined;
};
export type useUserByLicensedProductsQuery = {
  response: useUserByLicensedProductsQuery$data;
  variables: useUserByLicensedProductsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUserByLicensedProductsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUserByLicensedProductsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "475721f730a3548a4f4eefeb978ba00d",
    "id": "d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb",
    "metadata": {},
    "name": "useUserByLicensedProductsQuery",
    "operationKind": "query",
    "text": "query useUserByLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
  }
};
})();

(node as any).hash = "d128f30f97ec5f59ea08d8e5ff26d122";

export default node;
